<template>
  <div class="row mb-8">
    <div class="col-12 col-md-4 col-lg-4">
      <Card>
        <template #cardBody>
          <div class="d-flex align-items-center">
            <i class="fas fa-users fs-2hx me-8"></i>
            <div>
              <h4>{{ $t('events.presences.total_participators') }}</h4>
              <span class="fs-2x">{{ eventStats.total_participators < 10 ? '0' + eventStats.total_participators : eventStats.total_participators }}</span>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <div class="col-12 col-md-4 col-lg-4">
      <Card>
        <template #cardBody>
          <div class="d-flex align-items-center">
            <i class="fas fa-calendar fs-2hx me-8"></i>
            <div>
              <h4>{{ $t('events.presences.total_ateliers') }}</h4>
              <span class="fs-2x">{{ eventStats.total_ateliers < 10 ? '0' + eventStats.total_ateliers : eventStats.total_ateliers }}</span>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <div class="col-12 col-md-4 col-lg-4">
      <Card>
        <template #cardBody>
          <div class="d-flex align-items-center">
            <i class="fas fa-users fs-2hx me-8"></i>
            <div>
              <h4>{{ $t('events.presences.total_event_presences') }}</h4>
              <span class="fs-2x">{{ eventStats.total_event_presences < 10 ? '0' + eventStats.total_event_presences : eventStats.total_event_presences }}</span>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>

  <Card :title="$t('events.presences.event_guests_number')">
    <template #cardBody>
      <div class="table-responsive row">
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4">
          <thead>
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th class="min-w-100px text-center"></th>
            <th class="min-w-100px text-center">{{ $t('events.presences.total_participators') }}</th>
            <th class="min-w-100px text-center">{{ $t('events.presences.present_guests') }}</th>
          </tr>
          </thead>
          <tbody v-if="!atelierStats.length">
            <tr>
              <td colspan="3">
                <div class="h-250px d-flex justify-content-center align-items-center" >
                  <div class="text-center">
                    <div class="pt-8">
                      <Img filename="empty.png" alt=""
                          class="mw-100 h-125px h-sm-175px" />
                    </div>
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.presences.noData') }}</h2>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody class="scroll-y" style="max-height: 400px !important;" v-else>
            <template v-for="(atelierStat, index) in atelierStats" :key="index">
              <tr>
                <td class="dt-center text-center clickable" v-html="atelierStat.atelier_name">
                </td>
                <td class="dt-center text-center clickable">
                   {{ atelierStat.total_guests < 10 ? '0' + atelierStat.total_guests : atelierStat.total_guests }}  
                </td>
                <td class="dt-center text-center clickable">
                  {{ atelierStat.present_guests < 10 ? '0' + atelierStat.present_guests : atelierStat.present_guests }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import Ls from "@/services/ls";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import Button from "@/components/Button.vue";
import {useStore} from "vuex";
import { Theme } from "@/composables/theming";
import Img from "@/components/Img.vue";
import {useRoute} from "vue-router";

const route = useRoute()
const store = useStore()

const atelierStats = ref([])
const eventStats = ref({})

watch(() => route.query.tab, (value) => {
  if(value) {
    loadData()
  }
});

function loadData() {
  if(route.query.tab === 'tab-presences') {
    store.dispatch('events/getEventPresenceStats', route.params.id).then((res) => {
      let data = res.data
      eventStats.value = data.event_stats
      atelierStats.value = data.atelier_stats
    })
  }
}

onMounted(() => {
  loadData()
})
</script>

<style scoped>
  .participator-status-selector {
    background-color: var(--bs-primary)!important;
    color: white;
    border-radius: 8px;
    border: none;
    padding: 0.4rem 0.75rem;
  }
</style>